import { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

export const VEHICLE_VALUATION_BY_UUID_RESOURCE = `vehicle-valuation` as const;
export const VEHICLE_VALUATION_BY_UUID_API_PATH = `/v1/${VEHICLE_VALUATION_BY_UUID_RESOURCE}/{uuid}` as const;

export type VehicleValuationByUuidParameters =
  paths[typeof VEHICLE_VALUATION_BY_UUID_API_PATH]["get"]["parameters"]["query"];
type GeneratedVehicleValuationByUuidResponse =
  paths[typeof VEHICLE_VALUATION_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];
export type VehicleValuationByUuidResponse = GeneratedVehicleValuationByUuidResponse & {
  confirmedVehiclePreparationCosts?: number | null;
  priceAdjustmentPercentage: number;
  vehiclePreparationCosts: number;
};

export function useVehicleValuationByUuidQuery(
  uuid: string,
  options?: Options<VehicleValuationByUuidParameters, never>,
) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<VehicleValuationByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [VEHICLE_VALUATION_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<VehicleValuationByUuidResponse>(
        `/v1/${VEHICLE_VALUATION_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
